import React from 'react';
import Instructions from '../Instructions/Instructions';
import UploadFile from '../../../../../Shared/UploadFile/UploadFile';
import './orderSuccsess.scss';
import '../Instructions/instructions.scss';
import '../../../../../Shared/UploadFile/uploadFile.scss';
import {isEsimType} from '../../../../../../utilities/domain/simTypeConstants';

const getPhoneTypeLabel = (isEsim, isNewNumber) => {
    if (isEsim && isNewNumber) return 'הפעלת קו eSIM';
    if (isEsim && !isNewNumber) return 'ניוד והפעלת קו eSIM';
    if (!isEsim && isNewNumber) return 'קו חדש';
    return 'ניוד קו';
};

const renderPhoneTypeLabel = (isEsim, isNewNumber) => {
    const label = getPhoneTypeLabel(isEsim, isNewNumber);
    if (!label.includes('eSIM')) {
        return label;
    }
    const [before, after = ''] = label.split('eSIM');
    return (
        <>
            {before}
            <bdi dir='ltr'>eSIM</bdi>
            {after}
        </>
    );
};

const OrderSuccsessCellular = (props) => {
    const details = (isEsim, isNewNumber) => {
        let detailsList = null;
        if (isEsim && isNewNumber) {
            detailsList = props.esimData.successPageEsimNewLineTextList?.value;
        } else if (isEsim && !isNewNumber) {
            detailsList = props.esimData.successPageEsimNiudTextList?.value;
        } else if (!isEsim && isNewNumber) {
            detailsList = props.esimData.successPageSimNewLineTextList?.value;
        } else if (!isEsim && !isNewNumber) {
            detailsList = props.esimData.successPageSimNiudTextList?.value;
        }

        return <Instructions details={detailsList} />;
    };

    const cellularItem = (item) => {
        const cellularItems = props.cellularSettingsList.filter((x) => x.orderId == item.orderId);
        if (cellularItems.length > 0) {
            return cellularItems?.map((cellularItem, index) => {
                const isEsim = isEsimType(cellularItem.simType);
                const isNewNumber = cellularItem.phoneType == 'new';
                const isDisplayFileUpload = cellularItem.package?.isDisplayFileUpload;
                const fileUpload = cellularItem.package?.fileUpload;

                return (
                    <div key={index} className='cellular-item'>
                        <div className='info-card'>
                            <div className='info-card__header'>
                                <span className='info-card__label'>{renderPhoneTypeLabel(isEsim, isNewNumber)}</span>
                                <div className='info-card__phone'>
                                    <span className='info-card__phone-number'>{cellularItem.phoneNumberFormat}</span>
                                    <span className='info-card__phone-icon' aria-hidden='true' />
                                </div>
                            </div>
                        </div>
                        {details(isEsim, isNewNumber)}
                        {isDisplayFileUpload && (
                            <UploadFile
                                phoneNumber={cellularItem.phoneNumber}
                                text={fileUpload.expandedValue?.[0]?.description?.value || ''}
                                codeFile={fileUpload.expandedValue?.[0]?.nameFile?.value || ''}
                            />
                        )}
                    </div>
                );
            });
        }
    };

    return (
        <div className='order-succsess-cellular'>
            <div className='order-list'>
                {props.resultByOrders?.map((item, index) => {
                    if (item.isSuccess) {
                        return cellularItem(item, index);
                    }
                })}
            </div>
        </div>
    );
};

export default OrderSuccsessCellular;
